import React, { useEffect, useState } from 'react';
import AuthFunctions from '../services/AuthService';
import Session from './Session';
import { Container, Row, Col, Button, FormGroup, Input, InputGroup, InputGroupText, Spinner, FormFeedback } from 'reactstrap';
import { FaEye, FaEyeSlash } from 'react-icons/fa';
import { NavItem, NavLink } from 'reactstrap';
import { Link, useNavigate } from 'react-router-dom';

function Login({ action = null }) {
    const navigate = useNavigate();

    const [showPassword, setShowPassword] = useState(false);
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [usernameMissing, setUsernameMissing] = useState(false);
    const [passwordMissing, setPasswordMissing] = useState(false);
    const [signinFailed, setSigninFailed] = useState(false);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (action && action === 'logout') {
            Session.removeUserSession();
            window.location.href = '/login';
        } else {
            checkAuthenticated();
        }
    }, []);

    const checkAuthenticated = async () => {
        var isAuthenticated = await AuthFunctions.getAuthenticatedAsync();
        if (isAuthenticated) {
            window.location.href = '/';
        }
    }

    const validateInfo = () => {
        var usernameMissing = false;
        var passwordMissing = false;

        if (username.trim().length === 0) {
            usernameMissing = true;
        }

        if (password.trim().length === 0) {
            passwordMissing = true;
        }

        setUsernameMissing(usernameMissing);
        setPasswordMissing(passwordMissing);
        setLoading(false);
        setSigninFailed(false);

        return !usernameMissing && !passwordMissing;
    }

    const handleKeyPress = (event) => {
        if (event.key === 'Enter') {
            if (validateInfo()) {
                submitLogin();
            }
        }
    }

    const submitLogin = async () => {
        if (validateInfo()) {
            setLoading(true);

            var tokenData = await AuthFunctions.signInAsync(username, password);

            if (tokenData.token === null || tokenData.token.length === 0) {
                setSigninFailed(true);
            }
            else {
                setSigninFailed(false);
                Session.setUserSession(tokenData.userName, tokenData.token, tokenData.userId, tokenData.userRoles);
                window.location.href = '/';
            }

            setLoading(false);
        }
    }
    return (
        <Container className="d-flex justify-content-center align-items-center">
            <Row className="w-100">
                <Col md={{ size: 4, offset: 4 }}>
                    {signinFailed &&
                        <span style={{ color: 'red' }}>Username or password is incorrect!</span>
                    }
                    <FormGroup>
                        <Input
                            id="username"
                            type='text'
                            onChange={(e) => {
                                setUsername(e.target.value);
                                setUsernameMissing(false);
                            }}
                            className='form-control'
                            value={username}
                            onKeyPress={(e) => handleKeyPress(e)}
                            placeholder='Username'
                            invalid={usernameMissing}
                        />
                    </FormGroup>
                    <FormGroup>
                        <InputGroup>
                            <Input
                                id="password"
                                type={showPassword ? 'text' : 'password'}
                                onChange={(e) => {
                                    setPassword(e.target.value);
                                    setPasswordMissing(false);
                                }}
                                className='form-control'
                                value={password}
                                onKeyPress={(e) => handleKeyPress(e)}
                                placeholder='Password'
                                invalid={passwordMissing}
                            />
                            <InputGroupText
                                role="button"
                                onClick={() => {
                                    setShowPassword(!showPassword);
                                }}
                            >
                                {showPassword ? (
                                    <FaEyeSlash className="password-eye" />
                                ) : (
                                        <FaEye className="password-eye" />
                                )}

                            </InputGroupText>
                        </InputGroup>
                    </FormGroup>
                    <FormGroup>
                        <InputGroup>
                            <Button className='btn btn-primary w-100' disabled={loading} onClick={() => {
                                submitLogin();
                            }}>
                                {loading ? (
                                    <>
                                        <Spinner size="sm" className="me-2" /> Logging in...
                                    </>
                                ) : (
                                    "Login"
                                )}
                            </Button>
                        </InputGroup>
                    </FormGroup>
                    <Row>
                        <Col>
                            <p className="pull-left">
                                <NavLink tag={Link} className="forgot-link" to={'/forgot'}>Forgot your password?</NavLink>
                            </p>
                        </Col>
                    </Row>
                </Col>
            </Row>
        </Container>
    );
}

export default Login;
